import { useEffect } from 'react';
import type { MovieOption } from '../../shared/protocol';

/**
 * Full-screen enlarged poster + the movie's (invented) facts. A "← Back" button and
 * the backdrop/Esc all dismiss it. Used wherever a poster is shown — click to open in
 * non-voting views, double-click in the voting grid (so a single click still votes).
 */
export function PosterLightbox({ option, onClose }: { option: MovieOption; onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const p = option.poster;

  return (
    <div className="lightbox-backdrop" onClick={onClose}>
      <button
        className="lightbox-back"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        ← Back
      </button>
      <div className="lightbox-inner" onClick={(e) => e.stopPropagation()}>
        {option.posterUrl ? (
          <img src={option.posterUrl} alt={`${option.title} poster`} className="lightbox-img" />
        ) : (
          <div className="lightbox-img lb-placeholder">🎬</div>
        )}
        <div className="lightbox-meta">
          <h3>
            {option.title}
            {(p?.year ?? option.year) ? ` (${p?.year ?? option.year})` : ''}
          </h3>
          {p?.tagline && <div className="pm-tagline">“{p.tagline}”</div>}
          {p?.plot && <p className="soft">{p.plot}</p>}
          {p?.genre && <div className="pm-credit">{p.genre}</div>}
          {!p?.plot && option.hint && <p className="soft">{option.hint}</p>}
          {option.overview && !p && <p className="soft">{option.overview}</p>}
        </div>
      </div>
    </div>
  );
}
